var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgBookingcom = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1606 11.4487C10.1606 10.5926 10.8509 9.89948 11.7031 9.89948C12.5572 9.89948 13.2513 10.5926 13.2513 11.4487C13.2513 12.3047 12.5572 12.9998 11.7031 12.9998C10.8509 12.9998 10.1606 12.3047 10.1606 11.4487Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.63316 10.6719L2.47179 10.6709V8.08538C2.47179 7.53395 2.68677 7.24667 3.15915 7.18111H4.63316C5.68685 7.18111 6.36554 7.84533 6.3665 8.91734C6.36554 10.0183 5.70228 10.6719 4.63316 10.6719ZM2.47179 5.19327V3.02033C2.47179 2.42552 2.7234 2.14209 3.27773 2.10642H4.38348C5.33305 2.10642 5.89991 2.67327 5.89991 3.62285C5.89991 4.34684 5.51044 5.19327 4.41818 5.19327H2.47179ZM7.39513 6.2807L7.00373 6.0609L7.34596 5.7688C7.74218 5.42849 8.40737 4.66112 8.40737 3.33557C8.40737 1.3082 6.83309 0 4.39986 0H1.30627C0.58517 0.026993 0.0077123 0.613127 0 1.33905V12.8458H1.27446C1.27735 12.8477 1.27831 12.8458 1.28024 12.8477L4.45578 12.8458C7.16183 12.8458 8.90867 11.3727 8.90867 9.09183C8.90867 7.86461 8.34278 6.81478 7.39513 6.2807Z",
    fill: "currentColor"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBookingcom, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bookingcom.3196db3c.svg";
export { ForwardRef as ReactComponent };